import {ChangeDetectionStrategy,Component,afterNextRender,computed,inject,signal} from '@angular/core';
import {MATERIAL_IMPORTS} from '../../../shared/material-imports';
import {COMMON_IMPORTS} from '../../../shared/common-imports';
import {ConsentService} from '../../../common/consent/consent.service';

@Component({
	selector:'app-cookie-consent',
	changeDetection:ChangeDetectionStrategy.OnPush,
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS
	],
	templateUrl:'./cookie-consent.html',
	styleUrl:'./cookie-consent.scss'
})
export class CookieConsentComponent{
	private readonly consentService=inject(ConsentService);
	
	private readonly hydrated=signal<boolean>(false);
	protected readonly open=computed<boolean>(()=>this.hydrated()&&this.consentService.bannerOpen());
	protected readonly customising=signal<boolean>(false);

	protected readonly preferences=signal<boolean>(false);
	protected readonly analytics=signal<boolean>(false);
	protected readonly marketing=signal<boolean>(false);

	constructor(){
		afterNextRender(()=>{
			const state=this.consentService.state();
			if(state){
				this.preferences.set(state.preferences);
				this.analytics.set(state.analytics);
				this.marketing.set(state.marketing);
			}
			this.hydrated.set(true);
		});
	}

	protected acceptAll():void{
		this.consentService.acceptAll();
		this.customising.set(false);
	}

	protected rejectAll():void{
		this.consentService.rejectAll();
		this.customising.set(false);
	}

	protected saveChoice():void{
		this.consentService.save({
			preferences:this.preferences(),
			analytics:this.analytics(),
			marketing:this.marketing()
		});
		this.customising.set(false);
	}

	protected customise():void{
		this.customising.set(true);
	}
}
